import { TypeformRecord, TypeformRecordType } from 'generated-graphql/types';
import { atom, selectorFamily } from 'recoil';

enum StateKey {
  TypeformRecords = 'TypeformRecords'
}

export const typeformRecordsAtom = atom<TypeformRecord[] | null | undefined>({
  key: StateKey.TypeformRecords,
  default: null
});

export const typeformRecordSelector = selectorFamily<
  TypeformRecord | null | undefined,
  TypeformRecordType
>({
  key: StateKey.TypeformRecords,
  get:
    (type) =>
    ({ get }) => {
      const typeformRecords = get(typeformRecordsAtom);
      return typeformRecords?.find((record) => record.type === type) || null;
    }
});
